module.exports = __webpack_public_path__ + "f4590d98faef8fcf3ddf4f14d086433e.MP3";